export default {
  default: () => import("/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/layouts/default.vue"),
  sandbox: () => import("/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/layouts/sandbox.vue"),
  "store-flow": () => import("/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/layouts/storeFlow.vue")
}